export default __webpack_public_path__ + "src/assets/images/rsvp-intro-b.png";